{
  "w": 16,
  "h": 24,
  "rows": [
    "................",
    "......WWWW......",
    "................",
    "..YYYYYYYYYYYYYY",
    "..YYKKKKKKKKKKYY",
    "..YyyyyyyyyyyyyY",
    "................",
    "YYYYYYYYYYYYYYY.",
    "YYKKKKKKKKKKKYY.",
    "YyyyyyyyyyyyyyY.",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".....WWWWWWW...."
  ],
  "legend": {
    "K": "C.BLACK",
    "R": "C.RED",
    "Y": "C.B_YELLOW",
    "y": "C.YELLOW",
    "W": "C.B_WHITE"
  }
}
